import axios from "axios";
import User from "./user.js";
import { API_URL } from "./endpoints";

// URL base del backend para servir archivos e iniciar peticiones. Por defecto
// apunta al entorno de desarrollo local.
export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

//Funcion para obtener la ruta de la imagen
export const image_path = image => {
  if (image == null) {
    return null;
  }
  // Si la imagen ya es una URL absoluta, devolverla tal cual
  if (image.includes("http")) {
    return image;
  }
  // Si la ruta empieza por '/', asumimos que es relativa al backend
  if (image.startsWith("/")) {
    return `${BACKEND_URL}${image}`;
  }
  // En caso contrario las imágenes se sirven desde BACKEND_URL/storage
  return `${BACKEND_URL}/storage/${image}`;
};

  
//Funcion para obtener cortar un texto en frases
 export const trimText = (text , quantity = 1) =>{
    let newText = text.split('.').slice(0, quantity).join('.');
    return `${newText}...` 
  }

  //Funcion para obtener la seccion actual
  export const where = () => {
    let path = window.location.pathname;
    let pathArray = path.split('/');
    return `/${pathArray[1]}`;
  }

  export const roleToSpanish =(role) => {
    switch (role) {
      case 'admin':
        return 'Administrador';
      case 'employee':
        return 'Empleado';
      default:
        return 'No logueado';
    }
  }

  // export const logout = async (id) => {
  //   // localStorage.removeItem('token');
  //   await axios.post(`http://localhost:8000/api/logout`,null, {
  //     headers: {
  //       'Authorization': `Bearer ${sessionStorage.getItem('token')}`
  //     }
  //   });
  //   sessionStorage.removeItem('token');
  //   return new User();
  // }

export const logout = async () => {
  await axios.post(
    `${API_URL}/logout`,
    null,
    { withCredentials: true }
  );
  return new User();
};


